// Sidebar navigation prefs. Same shape as condtionsViewPrefs.js: string "1"/"0" values,
// every localStorage touch wrapped so a blocked/full storage never throws into the UI.

export const NAV_PINNED_KEY = "nav.sidebar.pinned"
export const NAV_SIDEBAR_FLAG_KEY = "nav.sidebar.enabled"

// ── Feature flag ─────────────────────────────────────────────────────────────
// Default ON for SWIFT SPA (unlike SwiftProcessingSPA's default-off rollout flag) — the
// sidebar IS the app's nav here. Kept as a flag anyway so it can be killed instantly without
// a rebuild if something's wrong post-deploy: set VUE_APP_SIDEBAR_NAV=0 per-build, or
// localStorage.setItem("nav.sidebar.enabled", "0") per-browser. The localStorage value wins
// when present, so a tester can also force it ON on a build that has it off.
export function isSidebarNavEnabled() {
  try {
    const override = window?.localStorage?.getItem(NAV_SIDEBAR_FLAG_KEY)
    if (override === "1") return true
    if (override === "0") return false
  } catch (e) {}
  return process.env.VUE_APP_SIDEBAR_NAV !== "0"
}

// ── Pinned ───────────────────────────────────────────────────────────────────
// Defaults to OPEN (pinned) so the rail matches the reference design out of the box;
// unpinning is remembered per-browser after that.
export function readNavPinned() {
  try {
    const v = window?.localStorage?.getItem(NAV_PINNED_KEY)
    if (v === "0") return false
    return true
  } catch (e) {
    return true
  }
}

export function writeNavPinned(val) {
  try {
    window?.localStorage?.setItem(NAV_PINNED_KEY, val ? "1" : "0")
  } catch (e) {}
}

// Cross-tab sync: pin in one tab, the others follow.
export function subscribeNavPinned(cb) {
  const handler = e => {
    if (e?.key !== NAV_PINNED_KEY) return
    cb(e?.newValue === "1")
  }
  window?.addEventListener?.("storage", handler)
  return () => window?.removeEventListener?.("storage", handler)
}
